import styles from './index.less';
import { FC } from 'react';
interface BillFooterProps {
  allAmount: string;
  btnText: string;
  paymentInfoVisible: boolean;
  btnClick: () => void;
  onPay: () => void;
}
const BillFooter: FC<BillFooterProps> = (props) => {
  const {
    allAmount = '0',
    btnText = '缴费',
    paymentInfoVisible,
    btnClick,
    onPay,
  } = props;
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <p>应缴合计：</p>
        <span>￥{allAmount}</span>
      </div>
      <div
        onClick={paymentInfoVisible ? onPay : btnClick}
        className={styles.btn}
      >
        {btnText}
      </div>
    </div>
  );
};

export default BillFooter;
